import _slicedToArray from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
// src/button-context.ts
import { createContext } from "@chakra-ui/react-context";
var _createContext = createContext({
    strict: false,
    name: "ButtonGroupContext"
  }),
  _createContext2 = _slicedToArray(_createContext, 2),
  ButtonGroupProvider = _createContext2[0],
  useButtonGroup = _createContext2[1];
export { ButtonGroupProvider, useButtonGroup };